import { useNavigate } from "react-router-dom";

export default function InvalidLinkPage() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    // replace: true removes current entry from history
    navigate("/", { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-50 to-white px-6">
      <div className="w-full max-w-md text-center">
        {/* Icon */}
        <div className="mx-auto mb-6 h-16 w-16 rounded-2xl bg-slate-100 ring-1 ring-inset ring-slate-200 flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8 text-slate-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9.75 14.25 7.5 12m0 0 2.25-2.25M7.5 12h6m3.75 0a4.5 4.5 0 0 0-4.5-4.5h-1.5m6 4.5a4.5 4.5 0 0 1-4.5 4.5h-1.5"
            />
          </svg>
        </div>

        {/* Heading */}
        <h1 className="text-2xl font-semibold text-slate-900">
          This link is not valid
        </h1>

        {/* Description */}
        <p className="mt-3 text-slate-600">
          The link you are trying to open is broken or has expired. Please check
          again or return to the homepage.
        </p>

        {/* Button */}
        <div className="mt-6">
          <button
            onClick={handleGoHome}
            className="inline-flex items-center rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Go to Homepage
          </button>
        </div>
      </div>
    </div>
  );
}
